import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Dialog } from '../../container/dialog';
import { ApiService } from '@usimweb/core/services';
import { AuthHandler } from '@usimweb/core-auth';
import { CONSET_STATUS } from '@usimweb/core/models';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'usimweb-consent-dialog',
  templateUrl: './consent-dialog.component.html',
  styleUrl: './consent-dialog.component.scss',
  standalone: false,
})
export class ConsentDialogComponent extends Dialog {
  public person: { name: string; lastName: string; mail: string } = { name: AuthHandler.firstName, lastName: AuthHandler.lastName, mail: AuthHandler.mail };
  public isSubmitDisabled = true;

  constructor(
    private dialogRef: MatDialogRef<ConsentDialogComponent>,
    private apiService: ApiService,
    private snackbar: MatSnackBar
  ) {
    super();
  }

  ngOnInit(): void {}

  save() {
    if (!this.isSubmitDisabled) {
      this.permitConsent();
    }
  }

  close() {
    this.dialogRef.close();
  }

  permitConsent() {
    this.apiService.postConsent(CONSET_STATUS.CONFIRMED).subscribe(() => {
      this.snackbar.open('Thank you! You will soon receive an confirmations email...', 'OK', { duration: 2000 });
    });
    this.dialogRef.close();
  }

  denyConsent() {
    this.apiService.postConsent(CONSET_STATUS.WITHDRAWN).subscribe(() => {});
    this.dialogRef.close();
  }

  toggleConsent(checked: boolean) {
    checked === true ? (this.isSubmitDisabled = false) : (this.isSubmitDisabled = true);
  }
}
